export enum AdminBoxSaleListItemAction {
  Approve,
  Archive,
  Preview,
  PreviewBox,
  Configure,
  HideContent,
  More,
  PublicContent,
  Remove,
}
